var map = {
	"./actua.svg": 4312,
	"./bosch.svg": 8475,
	"./comparco.svg": 4040,
	"./gree.svg": 1483,
	"./heliotek.svg": 6423,
	"./kaoDutos.svg": 9570,
	"./mitsubishi.svg": 3683,
	"./trisoft.png": 3705,
	"./ventokit.svg": 6402,
	"./wdb.svg": 2843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;